import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Cookies from "universal-cookie";
import actions, { useActions } from "../../../../redux/actions";

const cookies = new Cookies();

const MobileLangCurrChange = () => {
  const { i18n } = useTranslation();

  const StoreConfig = useSelector((state) => state.storeConfig);
  const currencyData = useSelector((state) => state.currencyData);

  const CurrencyActions = useActions(actions.CurrencyActions);

  const [currency, setCurrency] = useState({
    support: ["HKD"],
    primary: "HKD",
  });
  const [locale, setLocale] = useState({
    support: ["en", "zh"],
    default: "en",
  });

  useEffect(() => {
    setCurrency(
      StoreConfig.currency || {
        support: ["HKD"],
        primary: "HKD",
      }
    );
    setLocale(
      StoreConfig.locale || {
        support: ["en", "zh"],
        default: "en",
      }
    );
  }, [StoreConfig]);

  const changeLanguageTrigger = (e) => {
    const languageCode = e.target.value;
    cookies.set("lang", languageCode);
    i18next.changeLanguage(languageCode);
  };

  const getLanguageDisplay = (lang) => {
    const langKey = lang || i18n.language.toLowerCase();
    switch (langKey) {
      case "en":
        return "English";
      case "zh":
        return "繁體中文";
      case "zh-hans":
        return "简体中文";
      case "zh-Hans":
        return "简体中文";
      case "es":
        return "Español";
      case "ko":
        return "한국어";
      case "ja":
        return "日本語";
      default:
        return "English";
    }
  };

  const setCurrencyTrigger = (e) => {
    const currencyName = e.target.value;
    CurrencyActions.setCurrency(
      currencyName,
      StoreConfig.exchangeRate[currencyName]
    );
  };

  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.remove("active");
  };

  return (
    <div className="mobile-menu-middle">
      <div className="lang-curr-style">
        <span className="title mb-2">語言/Language</span>
        <select
          value={i18n.language}
          onChange={(e) => {
            changeLanguageTrigger(e);
            closeMobileMenu();
          }}
        >
          {Array.isArray(locale.support) &&
            locale.support.map((language) => (
              <option key={`lang_option_${language}`} value={language}>
                {getLanguageDisplay(language)}
              </option>
            ))}
        </select>
      </div>
      <div className="lang-curr-style">
        <span className="title mb-2">貨幣/Currency</span>
        <select
          value={currencyData?.currencyName}
          onChange={(e) => {
            setCurrencyTrigger(e);
            closeMobileMenu();
          }}
        >
          {Array.isArray(currency.support) &&
            currency.support.map((currencyOption) => (
              <option
                key={`currency_option_${currencyOption.toLowerCase()}`}
                value={currencyOption}
              >
                {currencyOption}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default MobileLangCurrChange;
